<template>
  <div class="in-box-wrapper">
    <el-card>
      <el-tabs v-model="activeTab">
        <template v-for="(item, index) in tabs">
          <el-tab-pane
            :label="item.label"
            :name="item.name"
            :key="index"
            v-if="authList.includes(item.auth)"
          ></el-tab-pane>
        </template>
      </el-tabs>
      <component :is="`service-${activeTab}`" :params="params" />
    </el-card>
  </div>
</template>
<script>
import replied from './replied'
import tag from './tag'
import { getList } from '@/server/category.js'
export default {
  name: 'in-box',
  components: {
    'service-tag': tag,
    'service-replied': replied
  },
  data() {
    return {
      tabs: [
        { label: this.$t('after-sales::email-setting::email_tag'), name: 'tag', auth: 'shop-management::after-sales::email-setting::tag' },
        { label: this.$t('after-sales::email-setting::email_sort'), name: 'replied', auth: 'shop-management::after-sales::email-setting::replied' }
      ],
      params: {},
      activeTab: '',
      options: {
        tag: [
          {
            label: this.$t('after-sales::email-setting::email_tag_name'),
            searchType: 'input',
            name: 'tag'
          }
        ]
      }
    }
  },
  created() {
    if (this.authPromise('after-sales::email-setting::replied')) {
      this.activeTab = 'replied'
    }
    if (this.authPromise('after-sales::email-setting::tag')) {
      this.activeTab = 'tag'
    }
  },
  async mounted() {
    if (this.$router.query && this.$router.query.name) {
      this.activeTab = this.$router.query.name
    }
  },
  methods: {
    async getEmail(resolve) {
      const { data } = await getList({
        pageNum: 1,
        pageSize: 10
      })
      if (data.code === this.$code) {
        const datas = data.data.items.map((item, i) => {
          return {
            label: item.name,
            value: item.id
          }
        })
        return resolve(datas)
      }
      return resolve([])
    },
    search(params) {
      // this.getListData(params)
    },
    init(params) {
      // this.getListData(params, true)
    }
  },
}
</script>
<style lang="scss" scoped></style>
